import axios from '@/services/api'

/**
 * @param {Object} query
 *
 * @returns {Promise<Object>}
 */
export const fetchPosts = (query = '') => {
	const url = `/api/threads${query}`
	return axios.get(url)
}

/**
 * @param {number} postId
 *
 * @returns {Promise<Object>}
 */
export const getPost = (postId) => {
	const url = `/api/threads/${postId}`
	return axios.get(url)
}

/**
 * @param {number} postId
 *
 * @returns {Promise<Object>}
 */
export const getPostComments = (postId) => {
	const url = `/api/thread-replies?thread_id=${postId}`
	return axios.get(url)
}


/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const addPost = (data) => {
	const url = `/api/threads`
	return axios.post(url, data)
}

/**
 * @param {Object} data
 * @param {Object} id
 *
 * @returns {Promise<Object>}
 */
export const editPost = (id, data) => {
	const url = `/api/threads/${id}`
	return axios.put(url, data)
}

/**
 * @param {Object} data
 * @param {Object} id
 *
 * @returns {Promise<Object>}
 */
export const removePost = (id) => {
	const url = `/api/threads/${id}`
	return axios.delete(url)
}

/**
 * @param {number} postId
 * @param {Object} postData
 *
 * @returns {Promise<Object>}
 */
export const updatePost = (postId, postData) => {
	const url = `/api/posts/${postId}`
	return axios.post(url, postData)
}

/**
 * @param {number} postId
 *
 * @returns {Promise<Object>}
 */
export const deletePost = (postId) => {
	const url = `/api/posts/${postId}`
	return axios.delete(url)
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const toggleLike = (data) => {
	const url = `/api/thread-upvote`
	return axios.post(url, data)
}

/**
 * @param {String} id
 *
 * @returns {Promise<Object>}
 */
export const toggleDislike = (id) => {
	const url = `/api/thread-upvote/${id}`
	return axios.delete(url)
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const toggleFollow = (data) => {
	const url = `/api/thread-follow`
	return axios.post(url, data)
}

/**
 * @param {String} id
 *
 * @returns {Promise<Object>}
 */
export const toggleUnFollow = (id) => {
	const url = `/api/thread-follow/${id}`
	return axios.delete(url)
}

/**
 * @param {Object} query
 * @returns {Promise<Object>}
 */
export const fetchPopularPosts = (query = {}) => {
	const url = '/api/posts/popular/all'
	return axios.get(url, { params: query })
}

/**
 * @param {Object} query
 * @returns {Promise<Object>}
 */
export const fetchPopularPostsByCategories = (query = {}) => {
	const url = '/api/posts/popular/'
	return axios.get(url, { params: query })
}

/**
 * @param {Object} data
 * @returns {Promise<Object>}
 */

export const getNearbyLocationPosts = (data) => {
	const url = '/api/posts/map/nearby'
	return axios.post(url, data)
}

/**
 * @param {Number} categoryId
 * @returns {Promise<Object>}
 */

export const getFeaturedPost = (categoryId) => {
	const url = `/api/events/${categoryId}`
	return axios.get(url)
}

/**
 * @param {Number} postId
 * @param {Object} reason
 * @returns {Promise<Object>}
 */

export const sendReport = (postId, reason) => {
	const url = `api/posts/${postId}/hide`
	return axios.post(url, { reason })
}

/**
 * @returns {Promise<Object>}
 */

export const getViolationsList = () => {
	const url = 'api/posts/hide-reasons'
	return axios.get(url)
}

/**
 * @returns {Promise<Object>}
 */

export const uploadFile = (data) => {
	const url = 'api/upload/upload'

	const formData = new FormData()
	formData.append('file', data)
	return axios.post(url, formData)
}

export const uploadVideo = (data) => {
	const url = 'api/threads/validate-video-link'
	const formData = new FormData()
	formData.append('videoLink', data)
	return axios.post(url, formData)
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */

export const votePoll = (data) => {
	const url = `/api/threads/poll-vote`
	return axios.post(url, data)
}


export const fetchTimerPoll = () => {
	const url = `api/polls/poll-length-list`
	return axios.get(url)
}

export const fetchPollsUser = (query) => {
	const url = `api/threads/poll-users${query}`
	return axios.get(url)
}

export const stopPoll = ({ thread_id }) => {
	const url = 'api/threads/poll-finished'
	return axios.post(url, {  thread_id })
}
